import React, { useContext,useEffect } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import { SharedInfoContext } from '../components/SharedInfoContextProvider';
import { useUserAPI } from '../components/useUserAPI';
import { iAeonClose } from '../library/iaeon_sdk.js';
import { iAeonSetData } from '../library/iaeon_sdk.js';
import { iAeonCheckSilentMode } from '../library/iaeon_sdk.js';
import { iAeonShowMemberPay } from '../library/iaeon_sdk.js';

//お買物API
import { callOkaimonoAPI } from "../components/okaimonoAPI";

import useSound from 'use-sound';
import se_05 from '../sound/s05_shopping_stop.mp3';
// import se_08 from '../sound/s08_se_delay0.mp3';

const motionConfig = {
	initial: {
		y: -30,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 30,
		opacity: 0,
	},
};
const modalBox_cover = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};


export const Modal = (props) => {


//----------------------------------------
// iAEON API：22.クローズAPI
//----------------------------------------

function callAPI_22(){
	let successCall_22 = function(success){
		var aaa = success;
		console.log('【iAeonClose】success：' + aaa);
	}
	let errorCall_22 = function(error){
		var bbb = error;
		console.log('【iAeonClose】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
	}
	iAeonClose().then(successCall_22).catch(errorCall_22);
}


//----------------------------------------
//お買物API：クローズAPI << 22.クローズAPI
//----------------------------------------

const okaimonoAPI_closeApp = async () => {
	try {
		console.log("----------------------------");
		console.log("【closeRegigoApp】call");
		const { callbackId, result } = await callOkaimonoAPI('closeRegigoApp');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【closeRegigoApp】success", result);
			console.log("【closeRegigoApp】result:", result.result);

		}else {
			console.log("【closeRegigoApp】error", result);
			console.log("【closeRegigoApp】result:", result.result);
			console.log("【closeRegigoApp】code:", result.error.code);
			console.log("【closeRegigoApp】message:", result.error.message);
			props.setErrFlg(true);
			var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			props.setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【closeRegigoApp】error', error);
		props.setErrFlg(true);
		props.setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


const [se05_stop] = useSound(se_05);

const sharedInfo = useContext(SharedInfoContext);
const { storeCode, updateStoreCode } = useContext(SharedInfoContext);

const closeModal = (e) => {
	// e.stopPropagation();
	console.log("close modal");
	// props.setScanFlg(false);
	setTimeout(function(){
		props.setScanFlg(false);
	}, 400);
	props.setErrFlg(false);
	props.setErr([]);

	if(props.gnav === true){
		//お買物API：画面遷移API（メニュー表示
		props.okaimonoAPI_didScreenTransition("menu");
	}else {
		if(props.page === "home" && props.err[1].indexOf("0000") !== -1){
			window.location.reload();
		// }else if(props.page === "intro" && props.err[1].indexOf("0000") !== -1){
		// 	window.location.reload();
		}else if(props.page === "qrscan"){
			props.setPage("shopping");
		}else if(props.page === "home" && props.err[1] === "29"){
			let closeStoreArr = props.closeStore;
			console.log("closeStoreArr:");
			console.log(closeStoreArr);
			closeStoreArr.push(sharedInfo.storeCode);
			props.setCloseStore(closeStoreArr);
			props.setActiveStore();
			updateStoreCode();

			//お買物API：画面遷移API（TOP画面
			props.okaimonoAPI_didScreenTransition("top");

		}else if(props.page === "intro" && props.err[1] === "29"){
			let closeStoreArr = props.closeStore;
			console.log("closeStoreArr:");
			console.log(closeStoreArr);
			closeStoreArr.push(sharedInfo.storeCode);
			props.setCloseStore(closeStoreArr);
			props.setActiveStore();
			updateStoreCode();

			//お買物API：画面遷移API（利用方法
			props.okaimonoAPI_didScreenTransition("how_to_use");

		}else if(props.page === "kuji_lottery"){
			console.log("props.regiType: " + props.regiType);
			props.setPage(props.regiType);
		}else if(props.page === "front_check"){
			props.setFrontCheckRetry(true);

			//お買物API：画面遷移API（レジご案内画面
			props.okaimonoAPI_didScreenTransition("guide_register");

		}else { //閉じるのみの場合
			if(props.page === "home"){
				//お買物API：画面遷移API（TOP画面
				props.okaimonoAPI_didScreenTransition("top");
			}else if(props.page === "intro"){
				//お買物API：画面遷移API（利用方法
				props.okaimonoAPI_didScreenTransition("how_to_use");
			}else if(props.page === "shopping"){
				//お買物API：画面遷移API（ホーム画面
				props.okaimonoAPI_didScreenTransition("home");
			}else if(props.page === "scan"){
				//お買物API：画面遷移API（スキャン画面
				props.okaimonoAPI_didScreenTransition("scan_item");
			}else if(props.page === "qrscan"){
				//お買物API：画面遷移API（支払いコードスキャン画面
				props.okaimonoAPI_didScreenTransition("scan_payment_code");
			}else if(props.page === "regi_senyou" || props.page === "regi_self" || props.page === "regi_yujin"){
				//お買物API：画面遷移API（支払い画面
				props.okaimonoAPI_didScreenTransition("wait_payment");
			}else if(props.page === "regi_senyou_comp" || props.page === "regi_self_comp"){
				//お買物API：画面遷移API（清算完了画面
				props.okaimonoAPI_didScreenTransition("complete_payment");
			}
		}
	}
	// se08_se();
	props.setSoundState("se08_se");
}
const closeKujiList = (e) => {
	e.stopPropagation();
	props.setErrFlg(false);
	props.setErr([]);
	if(props.page === "kuji_list"){
		console.log("props.regiType: " + props.regiType);
		props.setPage(props.regiType)
	}
	// se08_se();
	props.setSoundState("se08_se");
}

const recoveryShopping = (rchoice) => {
	props.setErrFlg(false);
	props.setErr([]);
	// se08_se();
	props.setSoundState("se08_se");
	setTimeout(function(){
		props.setRecoveryChoice(rchoice);
	}, 600);
}

//OTB取得失敗時のミニアプリ終了（STEP1
const closeAppOtbErr = (e) => {
	// se08_se();
	props.setSoundState("se08_se");
	//22.クローズAPI
	// callAPI_22();
	//お買物API：クローズAPI << 22.クローズAPI
	okaimonoAPI_closeApp();
}

//お買物中止
const closeApp = (e) => {
	e.stopPropagation();
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.add('is_show');
	});
	document.querySelectorAll('.modalCloseBtn').forEach(function(element) {
		element.classList.add('is_nouse');
	});
	if(sharedInfo.token !== null && sharedInfo.token !== undefined && sharedInfo.token !== ""){
		stopAPI();
	}
	if(props.shoppingData && props.shoppingData.data){
		console.log("props.shoppingData.data.sumItemCount: " + props.shoppingData.data.sumItemCount);
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			if(props.shoppingData.data.sumItemCount === 0){ //買物カゴが空
				//18.データ保存API（削除
				// callAPI_18_delete();
				//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
				okaimonoAPI_delShoppingData();
			}
		}
	}else{ //買物カゴが空
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//18.データ保存API（削除
			// callAPI_18_delete();
			//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
			okaimonoAPI_delShoppingData();
		}
	}

	if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
		if(props.page === "regi_senyou_comp" || props.page === "regi_self_comp" || props.page === "regi_yujin"){ //支払完了
			//18.データ保存API（削除
			// callAPI_18_delete();
			//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
			okaimonoAPI_delShoppingData();
		}
	}
	setTimeout(function(){
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//22.クローズAPI
			// callAPI_22();
			//お買物API：クローズAPI << 22.クローズAPI
			okaimonoAPI_closeApp();
		}else{ //OKAIMONO無効
			window.location.reload();
		}
	}, 6000);
	props.setSoundState("se08_se");
	setTimeout(function(){
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//24.サイレントモードチェックAPI
			// callAPI_24();
			//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
			okaimonoAPI_checkSilentMode();

		}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			//24.サイレントモードチェックAPI
			callAPI_24();

		}else{ //iAEON無効
			se05_stop();
		}
	}, 600);
}

//お買物中止：保存なし
const closeAppNoSave = (e) => {
	e.stopPropagation();
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.add('is_show');
	});
	document.querySelectorAll('.modalCloseBtn').forEach(function(element) {
		element.classList.add('is_nouse');
	});
	if(sharedInfo.token !== null && sharedInfo.token !== undefined && sharedInfo.token !== ""){
		stopAPI();
	}
	if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
		//18.データ保存API（削除
		// callAPI_18_delete();
		//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
		okaimonoAPI_delShoppingData();
	}
	setTimeout(function(){
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//22.クローズAPI
			// callAPI_22();
			//お買物API：クローズAPI << 22.クローズAPI
			okaimonoAPI_closeApp();
		}else{ //OKAIMONO無効
			window.location.reload();
		}
	}, 6000);
	props.setSoundState("se08_se");
	setTimeout(function(){
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//24.サイレントモードチェックAPI
			// callAPI_24();
			//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
			okaimonoAPI_checkSilentMode();

		}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			//24.サイレントモードチェックAPI
			callAPI_24();

		}else{ //iAEON無効
			se05_stop();
		}
	}, 600);
}

//お買物終了：買物開始前、精算完了後
const closeEND = (e) => {
	e.stopPropagation();
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.add('is_show');
	});
	document.querySelectorAll('.modalCloseBtn').forEach(function(element) {
		element.classList.add('is_nouse');
	});
	if(sharedInfo.token !== null && sharedInfo.token !== undefined && sharedInfo.token !== ""){
		stopAPI();
	}
	if(props.shoppingData && props.shoppingData.data){
		console.log("props.shoppingData.data.sumItemCount: " + props.shoppingData.data.sumItemCount);
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			if(props.shoppingData.data.sumItemCount === 0){ //買物カゴが空
				//18.データ保存API（削除
				// callAPI_18_delete();
				//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
				okaimonoAPI_delShoppingData();
			}
		}
	}else{ //買物カゴが空
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//18.データ保存API（削除
			// callAPI_18_delete();
			//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
			okaimonoAPI_delShoppingData();
		}
	}

	if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
		if(props.page === "regi_senyou_comp" || props.page === "regi_self_comp" || props.page === "regi_yujin" || props.page === "regi_meisai"){ //支払完了
			//18.データ保存API（削除
			// callAPI_18_delete();
			//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
			okaimonoAPI_delShoppingData();
		}
	}
	setTimeout(function(){
		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			//22.クローズAPI
			// callAPI_22();
			//お買物API：クローズAPI << 22.クローズAPI
			okaimonoAPI_closeApp();

		}else{ //OKAIMONO無効
			window.location.reload();
		}
	}, 600);
	props.setSoundState("se08_se");
}

const { bandColor, updateBandColor } = useContext(SharedInfoContext);


//----------------------------------------
// iAEON API：18.データ保存API（買物データ削除
//----------------------------------------

function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：');
		console.log(aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		console.log(bbb);
    }
    // window.iAeonMiniApp.iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
	iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
	// window.iAeonMiniApp.iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}


//----------------------------------------
//お買物API：データ保存API（買物データ削除 << 18.データ保存API（買物データ削除
//----------------------------------------

const okaimonoAPI_delShoppingData = async () => {
	try {
		console.log("----------------------------");
		console.log("【saveTransactionData:shopping_data】call");
		const { callbackId, result } = await callOkaimonoAPI('saveTransactionData', { key: 'shopping_data', value: '' });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【saveTransactionData:shopping_data】success", result);
			console.log("【saveTransactionData:shopping_data】result:", result.result);

		}else {
			console.log("【saveTransactionData:shopping_data】error", result);
			console.log("【saveTransactionData:shopping_data】result:", result.result);
		}

	} catch (error) {
		console.log('【saveTransactionData:shopping_data】error', error);
	}
};


//----------------------------------------
// iAEON API：24.サイレントモードチェックAPI
//----------------------------------------

function callAPI_24(){
    let successCall_24 = function(success){
        var aaa = success;
		console.log('【iAeonCheckSilentMode】success：' + aaa);
		console.log('【iAeonCheckSilentMode】is_silent_mode：' + aaa.is_silent_mode);

		if(aaa.is_silent_mode != true){ //サイレントモード無効
			se05_stop();
		}else{ //サイレントモード有効
			//22.クローズAPI
			// callAPI_22();
			//お買物API：クローズAPI << 22.クローズAPI
			okaimonoAPI_closeApp();
		}
    }
    let errorCall_24 = function(error){
		console.log('【iAeonCheckSilentMode】error: ' + error.error_code + " : " + error.message);
    }
	console.log("----------------------------");
	console.log('【iAeonCheckSilentMode】call');
    iAeonCheckSilentMode().then(successCall_24).catch(errorCall_24);
}


//----------------------------------------
//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
//----------------------------------------

const okaimonoAPI_checkSilentMode = async () => {
	try {
		console.log("----------------------------");
		console.log("【checkSilentMode】call");
		const { callbackId, result } = await callOkaimonoAPI('checkSilentMode');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【checkSilentMode】success", result);
			console.log("【checkSilentMode】result:", result.result);
			console.log("【checkSilentMode】status:", result.status);

			if(result.status === "0"){ //サイレントモードOFF
				se05_stop();
			}else{ //サイレントモードON
				//22.クローズAPI
				// callAPI_22();
				//お買物API：クローズAPI << 22.クローズAPI
				okaimonoAPI_closeApp();
			}

		}else {
			console.log("【checkSilentMode】error", result);
			console.log("【checkSilentMode】result:", result.result);
		}

	} catch (error) {
		console.log('【checkSilentMode】error', error);
	}
};


const reloadApp = (e) => {
	e.stopPropagation();
	window.location.reload();
}
const backShopping = (e) => {
	e.stopPropagation();
	props.setErrFlg(false);
	props.setErr([]);
	setTimeout(function(){
		props.setPage("shopping");
	}, 600);
	// se08_se();
	props.setSoundState("se08_se");
}

const onSettlecheck = (e) => {
	props.setErrFlg(false);
	props.setErr([]);
	// setTimeout(function(){
	// 	props.setSettlecheckFlg(true);
	// }, 600);
}

const StartShopping = () => {
	// props.setShowModal(false);
	// props.setErrTxt("");
	props.setErrFlg(false);
	props.setErr([]);
	// props.setPage("shopping")
	setTimeout(function(){
		props.setPage("attention");
	}, 600);
	// se08_se();
	props.setSoundState("se08_se");
}

const { stopAPI, data: stopData, loading: stopLoading, error: stopError } = useUserAPI();

useEffect(() => {
	if (stopData) {
		if (stopData.data) { //SUCCESS
			// console.log(`【stopAPI】 userinfoFlag: ${userData.data.userinfoFlag}`);

		} else { //ERROR
			// console.log('【stopAPI】 userinfoFlag: Data property is missing');
		}
	} else {
		// console.log('【stopAPI】 userinfoFlag: No Data');
	}
}, [stopData]);


//----------------------------------------
// iAEON API：27.会員バーコード画面表示API
//----------------------------------------

function callAPI_27(){
	let successCall_27 = function(success){
		var aaa = success;
		console.log('【iAeonShowMemberPay】success：' + aaa);
	}
	let errorCall_27 = function(error){
		console.log('【iAeonShowMemberPay】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
	}
	console.log("----------------------------");
	console.log('【iAeonShowMemberPay】call');
	iAeonShowMemberPay().then(successCall_27).catch(errorCall_27);

	props.setSoundState("se08_se");
	closeModal();
}


return (
	<AnimatePresence>
	{props.errFlg && (
	<>
		{/* {props.err[0] === true ? ( */}
		{props.errFlg ? (
			<section className="modalBox">
				<div className="modalBox_wrap">
					<div className="modalBox_in">
						<motion.div className={`modalBox_info`}
							initial={'initial'}
							animate={'animate'}
							exit={'hidden'}
							variants={motionConfig}
							transition={{duration: 0.3, ease: 'easeInOut'}}
							style={
								(props.err[1] === "shopping_cancel" || props.err[1] === "shopping_cancel04")
									? { padding: "32px 20px" }
									: {}
							}
						>
							{
								(() => {
									if (props.errNum === "ERR001") { //ERR001
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return(
											<>
											<p className="modalBox_tit">保存されている<br/>商品情報があります</p>

											<div className="commonBtn commonBtn01" onClick={StartShopping}><span>お買い物を続ける</span></div>
											<div className="commonBtn commonBtn02" onClick={StartShopping}><span>新しくお買い物をはじめる</span></div>

											<p className="modalBox_txt modalBox_alert">※新しくはじめると商品情報は削除されます</p>
											</>
										)
									} else if (props.errNum === "ERR002") { //ERR002
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return(
											<>
											<p className="modalBox_tit">前回のお買い物が完了しておりません。<br/>サービスカウンターでレシート印刷を行ってください。</p>

											<div className="commonBtn commonBtn01 commonBtn01_small" onClick={closeModal}><span>レシート印刷用QRコード表示へ</span></div>
											<div className="commonBtn commonBtn04" onClick={closeModal}><span>キャンセル</span></div>
											</>
										)
									} else if (props.errNum === "ERR003") { //ERR003
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">前回のお買い物のお支払いが完了しておりません。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>お支払へ</span></div>
											<div className="commonBtn commonBtn04" onClick={closeModal}><span>キャンセル</span></div>
											</>
										)
									} else if (props.errNum === "ERR004") { //ERR004
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">カートがいっぱいです。<br/>精算してください。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
											</>
										)
									} else if (props.errNum === "ERR005") { //ERR005
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">カメラの利用が許可されていません。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
											</>
										)
									// } else if (props.err[1] === "000018") { //000018
									// 	return (
									// 		<>
									// 		<p className="modalBox_tit">バーコードが読み取れませんでした。</p>

									// 		<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
									// 		</>
									// 	)
									} else if (props.errNum === "ERR007") { //ERR007
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">商品情報がありません。<br/>係員をお呼びください。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
											</>
										)
									} else if (props.errNum === "ERR008") { //ERR008
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">こちらは医療品となります。医薬品担当者をお呼びください。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
											</>
										)
									} else if (props.errNum === "ERR009") { //ERR009
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">クーポンは精算時にご利用ください。</p>

											<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
											</>
										)
									} else if (props.err[1] === "shopping_cancel") { //お買い物中止（買い物中 0件
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<div className="modalBox_alertImg">
												<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
											</div>
											<p className="modalBox_tit" style={{fontWeight: "600",width: "100%"}}>レジゴーを終了しますか？</p>
											{/* <p className="modalBox_txt" style={{color: "#eb3955"}}>終了すると、レジゴーでスキャンした商品情報はすべて削除されます。</p> */}

											<div className="commonBtn commonBtn01 modalCloseBtn" onClick={closeAppNoSave} style={{maxWidth: "264px"}}><span>終了する</span></div>

											<div className="commonBtn commonBtn04 modalCloseBtn" onClick={closeModal} style={{maxWidth: "264px"}}><span>お買物に戻る</span></div>
											</>
										)
									} else if (props.err[1] === "shopping_cancel04") { //お買い物中止（買い物中 0件以外
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<div className="modalBox_alertImg">
												<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
											</div>
											<p className="modalBox_tit" style={{fontWeight: "600",width: "100%"}}>レジゴーを終了しますか？</p>
											<p className="modalBox_txt" style={{color: "#eb3955"}}>終了すると、レジゴーでスキャンした商品情報はすべて削除されます。</p>

											<div className="commonBtn commonBtn01 modalCloseBtn" onClick={closeAppNoSave}><span>終了する</span></div>

											<div className="commonBtn commonBtn04 modalCloseBtn" onClick={closeModal}><span>お買物に戻る</span></div>
											</>
										)
									} else if (props.err[1] === "shopping_cancel03") { //お買い物終了（買物開始前、レジ転送後
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">お買い物を終了します<br />よろしいですか？</p>

											<div className="commonBtn commonBtn01 modalCloseBtn" onClick={closeEND}><span>OK</span></div>

											<div className="commonBtn commonBtn04 modalCloseBtn" onClick={closeModal}><span>キャンセル</span></div>
											</>
										)
									} else if (props.err[1] === "shopping_cancel02") { //お買い物中止（保存するか確認
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<div className="modalBox_alertImg">
												<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
											</div>
											<p className="modalBox_tit alert">お買い物の中断</p>
											<p className="modalBox_txt">お買物アプリに移動します<br/>
												商品情報を保存しますか？</p>

											<div className="modalBtn modalBtn01 modalCloseBtn" onClick={closeApp}><span>保存して移動</span></div>
											<div className="modalBtn modalBtn02 modalCloseBtn" onClick={closeAppNoSave}><span>保存しない</span></div>
											<div className="modalBtn modalBtn03 modalCloseBtn" onClick={closeModal}><span>お買い物を続ける</span></div>

											</>
										)
									} else if (props.err[1] === "shopping_recovery") { //買物復元
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<p className="modalBox_tit">保存されている商品情報があります</p>

											<div className="modalBtn modalBtn01" onClick={()=>recoveryShopping(true)}><span>お買い物を続ける</span></div>
											<div className="modalBtn modalBtn02" onClick={()=>recoveryShopping(false)}><span>新しくお買い物をはじめる</span></div>

											<p className="modalBox_alert ls-05">※新しくはじめると商品情報は削除されます</p>

											</>
										)
									} else if (props.err[1] === "otb_error_step1") { //OTB取得失敗：STEP1
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<div className="modalBox_alertImg">
												<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
											</div>
											<p className="modalBox_tit alert">iAEON会員コードが<br />正しく登録されません<br />でした</p>
											<p class="modalBox_txt02">レジゴーを閉じて<br/>レジでiAEON会員コードを<br/>スキャンしてください</p>

											<div className="modalBtn modalBtn01" onClick={closeAppOtbErr}><span>レジゴーを閉じる</span></div>
											<div className="modalBtn modalBtn03 modalCloseBtn" onClick={closeModal}><span>会員コードを登録しない</span></div>

											</>
										)
									} else if (props.err[1] === "otb_error_step2") { //OTB取得失敗：STEP2
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										return (
											<>
											<div className="modalBox_alertImg">
												<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
											</div>
											<p className="modalBox_tit alert">iAEON会員コードが<br />正しく登録されません<br />でした</p>
											<p className="modalBox_txt">会員コードを表示して<br />レジでスキャンしてください</p>

											<div className="modalBtn modalBtn01" onClick={callAPI_27}><span>会員コードを表示する</span></div>
											<div className="modalBtn modalBtn03 modalCloseBtn" onClick={closeModal}><span>会員コードを登録しない</span></div>

											</>
										)
									} else { //ユーザーAPIエラー
										//お買物API：画面遷移API（ポップアップ表示
										props.okaimonoAPI_didScreenTransition("popup");

										const erNum = props.err[2].split(";")[0];
										const erTit_jp = props.err[2].split(";")[1];
										const erTxt_jp = props.err[2].split(";")[2];
										const erTit_en = props.err[2].split(";")[3];
										const erTxt_en = props.err[2].split(";")[4];
										if(erTit_jp.length === 0){
											return ( //タイトル・アイコンなし
												<>
												{/* <p className="modalBox_tit">{props.errTxt}</p> */}

												{/* <div className="modalBox_alertImg">
													<img src="/images/icn_caution.svg" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p> */}
												<p className="modalBox_tit">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
												{/* {
													(() => {
														if (props.errNum === "29") {
														return(
															<div className="commonBtn commonBtn03" onClick={closeApp}><span>お買い物を中止する</span></div>
														)
														} else {
														return (
															<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
														)
														}
													})()
												} */}
												</>
											)
										}else if(props.err[1] === "26" || props.err[1] === "27"){ //トークン不正、トークン有効期限切れ → スタート画面へ
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={reloadApp}><span>閉じる</span></div>
												</>
											)
										}else if(props.err[1] === "32"){ //フロントチェックエラー
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												{/* <div className="commonBtn commonBtn01" onClick={reloadApp}><span>閉じる</span></div> */}
												</>
											)
										}else if(props.err[1] === "33" || props.err[1] === "34"){ //転送できるレジがない、代表QRコード異常 → 買物一覧画面へ
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={backShopping}><span>閉じる</span></div>
												</>
											)
										}else if(props.err[1] === "35"){ //タイムアウト、通信エラー
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												{/* <div className="commonBtn commonBtn01" onClick={reloadApp}><span>閉じる</span></div> */}
												</>
											)
										}else if(props.err[1] === "000"){ //スタート画面：タイムアウト、通信エラー
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={reloadApp}><span>閉じる</span></div>
												</>
											)
										}else if(props.err[1] === "666"){ //決済確認エラー：STATUS0
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">お支払いが確認<br/>できませんでした</p>
												<p className="modalBox_txt">レジにてお支払いを<br/>お願いします。</p>

												<p className="modalBox_alert">すでにお支払いが完了しているにも関わらずこの画面が出る場合は、大変恐れ入りますが、お近くの従業員までお申し出下さい。</p>

												<div className="modalBtn modalBtn01" onClick={onSettlecheck}><span>閉じる</span></div>
												</>
											)
										}else if(props.err[1] === "999"){ //くじ引き履歴API
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>

												<div className="modalBox_alertImg">
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={closeKujiList}><span>閉じる</span></div>
												</>
											)
										}else{ //タイトル・アイコンあり
											//お買物API：画面遷移API（ポップアップ表示
											props.okaimonoAPI_didScreenTransition("popup");

											return (
												<>
												{/* <p className="modalBox_tit">{props.errTxt}</p> */}

												<div className="modalBox_alertImg">
													{/* <img src="/images/icn_caution.svg" alt="" width="48" height="48"/> */}
													<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
												</div>
												<p className="modalBox_tit alert">{erTit_jp}</p>
												<p className="modalBox_txt">{erTxt_jp}</p>
												<div className="commonBtn commonBtn01" onClick={closeModal}><span>閉じる</span></div>
												</>
											)
										}
								}
								})()
							}

						</motion.div>
					</div>
					<motion.div className="modalBox_cover"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={modalBox_cover}
						transition={{duration: 0.35, ease: 'linear'}}
					></motion.div>
				</div>
			</section>

		) : ( // showModalがfalseの場合はModal非表示
			<></>
		)}
	</>
	)}
	</AnimatePresence>
)
}
